<div class="zn-form" [formGroup]="form">
  <fieldset>
    <div class="row">
      @if (!shouldHideAreaToBeAdjustedField()) {
      <div class="col-6">
        <div class="form-control-container">
          <label class="form-label" for="areaToBeAdjusted">
            {{ 'Geographic::Entity.StandAreaMaintenance.AreaToBeAdjusted' | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <input
            id="areaToBeAdjusted"
            class="form-control"
            type="number"
            formControlName="areaToBeAdjusted"
            min="0.01"
            step="0.01"
            inputmode="decimal"
            [placeholder]="`${localizationResource}::EnterNumber` | abpLocalization"
          />
          @if (fieldInvalid('areaToBeAdjusted')) {
            @if (form.get('areaToBeAdjusted')?.hasError('required')) {
              <small class="invalid-feedback d-block">
                {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
              </small>
            }
            @if (form.get('areaToBeAdjusted')?.hasError('min')) {
              <small class="invalid-feedback d-block">
                {{ `${localizationResource}::MustBeGreaterThan` | abpLocalization : '0' }}
              </small>
            }
          }
        </div>
      </div>
      <div class="col-6">
        <div class="form-control-container">
          <lib-stand-gis
            [canFetchGisArea]="!!resolvedParentStandName() && !loading()"
            [name]="resolvedParentStandName()"
            (updatedGisArea)="onUpdateGisArea($event)"
          ></lib-stand-gis>
        </div>
      </div>
      }
      <div class="col-6">
        <div class="form-control-container">
          <label class="form-label" for="standAreaMaintenanceTypeId">
            {{ 'Geographic::Entity.StandAreaMaintenance.StandAreaMaintenanceType' | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <zn-single-select
            id="standAreaMaintenanceTypeId"
            [options]="adjustmentTypeOptions()"
            [showSearch]="true"
            formControlName="standAreaMaintenanceTypeId"
            [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
            [localizationResource]="localizationResource"
            [openUp]="false"
          >
          </zn-single-select>
          @if (fieldInvalid('standAreaMaintenanceTypeId')) {
            <small class="invalid-feedback d-block">
              {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
            </small>
          }
        </div>
      </div>

      <div class="col-6">
        <div class="form-control-container">
          <label class="form-label" for="adjustmentReasonId">
            {{ 'Geographic::Entity.StandAreaMaintenance.AdjustmentReason' | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <zn-single-select
            id="adjustmentReasonId"
            [options]="reasonOptions()"
            [showSearch]="true"
            formControlName="adjustmentReasonId"
            [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
            [localizationResource]="localizationResource"
            [openUp]="false"
          >
          </zn-single-select>
          @if (fieldInvalid('adjustmentReasonId')) {
            <small class="invalid-feedback d-block">
              {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
            </small>
          }
        </div>
      </div>

      <div class="col-6">
        <div class="form-control-container">
          <label class="form-label" for="periodId">
            {{ 'Geographic::Entity.StandAreaMaintenance.Period' | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <zn-single-select
            id="periodId"
            [optionsLoader]="periodsLoader"
            [showSearch]="true"
            formControlName="periodId"
            [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
            [localizationResource]="localizationResource"
            [openUp]="false"
          >
          </zn-single-select>
          @if (fieldInvalid('periodId')) {
            <small class="invalid-feedback d-block">
              {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
            </small>
          }
        </div>
      </div>
      <div class="col-6">
        <div class="form-control-container">
          <label class="form-label" for="notes">
            {{ 'Geographic::Entity.StandAreaMaintenance.Notes' | abpLocalization }}
          </label>
          <input
            id="notes"
            class="form-control"
            type="text"
            formControlName="notes"
            [attr.maxlength]="notesMaxLength"
            [placeholder]="`${localizationResource}::EnterText` | abpLocalization"
          >
          @if (fieldInvalid('notes') && form.get('notes')?.hasError('maxlength')) {
            <small class="invalid-feedback d-block">
              {{ `${localizationResource}::DefaultErrorMaxLength` | abpLocalization : notesMaxLength }}
            </small>
          }
        </div>
      </div>
      @if (!shouldHideIsAreaUpdatedField()) {
        <div class="col-6">
          <div class="form-control-container p-0">
            <div class="form-control-container form-check-inner-container form-check p-0">
              <input
                id="isAreaUpdated"
                class="form-check-input order-first check-lg"
                type="checkbox"
                formControlName="isAreaUpdated"
              />
              <label class="form-label" for="isAreaUpdated">
                {{ 'Geographic::Entity.StandAreaMaintenance.IsAreaUpdated' | abpLocalization }}
              </label>
            </div>
          </div>
        </div>
      }
    </div>
  </fieldset>
</div>
